import CreateClientComponent from "@components/CreateClientComponent/CreateClientComponent";
import InfoSupp from "@components/createQuote/InfoClient/InfoClient";
import { Stack } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { CreateModalContext } from "layouts/appLayout/layout";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import "./PersonalDetails.scss";

const PersonalDetails = ({
  sellerName,
  sellerAddress,
  sellerEmail,
  selectedCompanyId,
  handleCompanyChange,
  isLoadingCompanies,
  companiesError,
  companiesData,
  selectedClientId,
  setSelectedClientId,
  clientsData,
  setClientName,
  setClientEmail,
  setClientAddress,
  isLoadingClients,
  clientsError,
  clientName,
  clientAddress,
  currentUser,
  idUserClient,
  currentClientData,
}) => {
  const { t } = useTranslation();
  const [clientData, setClientData] = useState(
    currentClientData ? currentClientData : null
  );
  const { toggleCreateModal } = useContext(CreateModalContext);

  const handleAddClient = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateClientComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("client.create_form.title")
    );
  };
  return (
    <Stack
      sx={{
        backgroundColor: "#f8fbff",
        padding: "1.5rem",
        borderRadius: "16px",
      }}>
      <div className="details-personnel">
        <p className="detail-title">{t("invoice.details_personnel")}</p>
        <Stack
          className="details-company-client infos"
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            flexDirection: "row",
          }}>
          <InfoSupp
            address={currentUser?.companyId?.address}
            email={sellerEmail}
            name={sellerName}
            phone={currentUser?.companyId?.phone}
          />

          {!idUserClient && (
            <div className="name-selects">
              <AnimatePresence mode="wait">
                <motion.div
                  key="client-form"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                  style={{ width: "100%" }}>
                  <div className="input-with-button">
                    <select
                      className="table-input"
                      value={selectedCompanyId}
                      onChange={(e) => handleCompanyChange(e.target.value)}
                      required>
                      <option value="">{t("invoice.choose_company")}</option>
                      {companiesData?.map((client) => (
                        <option key={client._id} value={client._id}>
                          {client?.name}
                        </option>
                      ))}
                      {companiesData.length === 0 && !isLoadingCompanies && (
                        <option disabled>
                          {t("invoice.no_companies_available")}
                        </option>
                      )}
                    </select>

                    <button
                      type="button"
                      className="add-button"
                      onClick={handleAddClient}>
                      +
                    </button>
                  </div>

                  <p className="mt-3">{t("invoice.recipient")}</p>
                  <div className="input-with-button">
                    <select
                      className="table-input"
                      value={selectedClientId}
                      onChange={(e) => {
                        const clientId = e.target.value;
                        setSelectedClientId(clientId);

                        const selectedClient = clientsData.find(
                          (client) => client._id === clientId
                        );
                        setClientData(selectedClient);

                        if (selectedClient) {
                          setClientName(selectedClient.name);
                          setClientEmail(selectedClient.email || "");
                          setClientAddress(selectedClient.address || "");
                        }
                      }}
                      required>
                      <option value="">{t("invoice.choose_client")}</option>
                      {clientsData?.map((client) => (
                        <option key={client._id} value={client._id}>
                          {client.name}
                        </option>
                      ))}
                      {clientsData.length === 0 &&
                        selectedCompanyId &&
                        !isLoadingClients && (
                          <option disabled>
                            {t("invoice.no_clients_for_company")}
                          </option>
                        )}
                    </select>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          )}

          {clientData && (
            <div className="detail-client">
              <AnimatePresence mode="wait">
                <motion.div
                  key="client-details"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  transition={{ duration: 0.3 }}>
                  <InfoSupp
                    address={clientData?.address}
                    email={clientData?.email}
                    name={clientData?.name}
                    phone={clientData?.phone}
                  />
                </motion.div>
              </AnimatePresence>
            </div>
          )}
        </Stack>
      </div>
    </Stack>
  );
};

export default PersonalDetails;
